import { useMemo } from "react";

import { useOnboardStripe } from "@/services/UserService";
import { IActionCardProps } from "@/components/misc/ActionCard";
import { SITE_PATHS } from "@/config/routing";
import Icon from "@/components/misc/Icon";

function useUserActions() {
  const { isReady, canOnboard } = useOnboardStripe();

  const actions = useMemo(() => {
    const actions: IActionCardProps[] = [];

    actions.push({
      icon: "profile_star.svg",
      content:
        "Enhance your credibility and impress potential clients by completing your profile today!",
      color: "#F1F5F9",
      ctaProps: {
        children: "Complete profile",
        link: SITE_PATHS.EDIT_PROFILE_PAGE,
      },
    });

    if (isReady && canOnboard) {
      actions.push({
        icon: (
          <Icon isSrcRelative src="alert_round.svg" customSize="3rem" />
        ),
        content:
          "Set up your payment information so you can receive your earnings.",
        color: "#F1F5F9",
        ctaProps: {
          children: "Set up Payments",
          link: SITE_PATHS.PAYOUT_ONBOARDING_PAGE,
        },
      });
    }

    return actions;
  }, [canOnboard, isReady]);

  return {
    isLoading: !isReady,
    actions,
  };
}

export default useUserActions;
